import useChatRestClient from '@/Api/ChatRestClient';
import {useMutation} from '@tanstack/react-query';

export default function useGetAvailableSlots(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const ChatRestClient = useChatRestClient();
  type AvailableSlotsResponse = {
    success: boolean;
    [key: string]: any;
  };

  const mutation = useMutation<
    AvailableSlotsResponse,
    Error,
    {mentor_id: string; current_date?: string; weeks?: string}
  >(
    async filters => {
      const queryParams = new URLSearchParams(filters);
      const queryString = queryParams.toString();
      const response = await ChatRestClient.get(
        `subscription/v1/mentor-availability?${queryString}`,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess && data?.success) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
